import { create } from 'zustand';

const useIntercomStore = create((set, get) => ({
  notifications: [],
  isConnected: false,
  activeCall: null,
  callIdMap: {}, // Maps intercomId -> callId for acknowledgment
  
  addNotification: (notification) => set((state) => ({
    notifications: [notification, ...state.notifications.filter(n => n.id !== notification.id)].slice(0, 50)
  })),
  
  removeNotification: (id) => set((state) => ({
    notifications: state.notifications.filter(n => n.id !== id),
    activeCall: state.activeCall?.id === id ? null : state.activeCall
  })),
  
  markAnswered: (id, answeredBy) => set((state) => ({
    notifications: state.notifications.map(n => n.id === id ? { ...n, answered: true, answeredBy } : n)
  })),
  
  setConnected: (connected) => set({ isConnected: connected }),
  
  setActiveCall: (notification) => set({ activeCall: notification }),
  
  clearActiveCall: () => set({ activeCall: null }),
  
  clearAll: () => set({ notifications: [], activeCall: null, callIdMap: {} }),
  
  // Map intercomId to callId for acknowledgment
  setCallId: (intercomId, callId) => set((state) => ({
    callIdMap: { ...state.callIdMap, [intercomId]: callId }
  })),
  
  // Get callId for an intercomId
  getCallId: (intercomId) => get().callIdMap[intercomId],
  
  // Clear callId mapping
  clearCallId: (intercomId) => set((state) => {
    const newMap = { ...state.callIdMap };
    delete newMap[intercomId];
    return { callIdMap: newMap };
  }),
}));

export default useIntercomStore;
